import { hideModalEventHandler } from '../shared/shared-hide-modal-event';

export const uouHideModalEvent = hideModalEventHandler(223);
